var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-icon-image d-flex justify-center align-center"},[_c('v-img',{style:(_vm.style),attrs:{"src":_vm.src}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }